/* Vivawalls wishlist share — 挂在现有 vw 收藏体系上(localStorage.vw_wishlist_handles)。
   /pages/wishlist            → 标题下加「Share my favorites」按钮(ERP 生成短链)
   /pages/wishlist?w=<code>   → 渲染朋友分享的清单(套用 vw-grid/vw-card 原生样式),
                                每件可一键存入自己的收藏(写回 vw_wishlist_handles)。 */
(function () {
  if (window.__VW_WL_SHARE__) return;
  window.__VW_WL_SHARE__ = 1;
  if (location.pathname.indexOf('/pages/wishlist') === -1) return;

  var KEY = 'vw_wishlist_handles';
  var API = 'https://erp.vivawalls.net/analytics/wishlist-share';

  function load() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function save(list) { localStorage.setItem(KEY, JSON.stringify(list)); }

  var css = document.createElement('style');
  css.textContent =
    '.vwsh-btn{display:inline-flex;align-items:center;gap:8px;margin:6px 0 18px;padding:10px 20px;' +
    'border:1px solid #333;border-radius:24px;background:transparent;cursor:pointer;font:inherit;font-size:14px}' +
    '.vwsh-btn:hover{background:#333;color:#fff}' +
    '.vwsh-note{margin:0 0 16px;color:#666;font-size:14px}' +
    '.vwsh-save{display:block;width:100%;margin-top:8px;padding:8px 0;border:1px solid #ddd;border-radius:6px;' +
    'background:#fff;cursor:pointer;font-size:13px}' +
    '.vwsh-save.on{background:#f6efe2;border-color:#c9a227;color:#8a6423}';
  document.head.appendChild(css);

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var container = document.querySelector('.vw-container') || document.querySelector('main') || document.body;
    var title = container.querySelector('.vw-title') || container.querySelector('h1');
    var grid = container.querySelector('.vw-grid');
    var code = new URLSearchParams(location.search).get('w');

    if (code) {
      // ---- 朋友视角:只读清单 ----
      if (grid) grid.style.display = 'none';
      var ownContent = container.querySelector('.vw-content');
      if (ownContent) ownContent.style.display = 'none';
      if (title) title.textContent = 'A friend shared their favorites with you 💛';
      var shGrid = document.createElement('div');
      shGrid.className = 'vw-grid';
      (title || container).insertAdjacentElement('afterend', shGrid);
      fetch(API + '/' + encodeURIComponent(code) + '/')
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (d) {
          d.handles.forEach(function (h) {
            fetch('/products/' + h + '.js')
              .then(function (r) { if (!r.ok) throw 0; return r.json(); })
              .then(function (p) {
                var img = p.featured_image || (p.images && p.images[0]) || '';
                var card = document.createElement('div');
                card.className = 'vw-card';
                var saved = load().indexOf(h) > -1;
                card.innerHTML =
                  '<div class="vw-imgwrap"><a href="/products/' + h + '">' +
                  (img ? '<img loading="lazy" src="' + img + '" alt="" style="width:100%;display:block">' : '') +
                  '</a></div>' +
                  '<a href="/products/' + h + '" style="display:block;margin-top:8px;font-size:14px;' +
                  'text-decoration:none;color:inherit">' + p.title + '</a>' +
                  '<button class="vwsh-save' + (saved ? ' on' : '') + '">' +
                  (saved ? '♥ Saved to my favorites' : '♡ Save to my favorites') + '</button>';
                var b = card.querySelector('.vwsh-save');
                b.addEventListener('click', function () {
                  var list = load();
                  if (list.indexOf(h) === -1) {
                    list.push(h);
                    save(list);
                    b.classList.add('on');
                    b.textContent = '♥ Saved to my favorites';
                  }
                });
                shGrid.appendChild(card);
              }).catch(function () {});
          });
        })
        .catch(function () {
          shGrid.innerHTML = '<p class="vwsh-note">This shared link is invalid or expired.</p>';
        });
      return;
    }

    // ---- 自己视角:分享按钮 ----
    if (!load().length) return;   // 空收藏不显示
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vwsh-btn';
    btn.innerHTML = '🔗 <span>Share my favorites</span>';
    btn.addEventListener('click', function () {
      var sp = btn.querySelector('span');
      sp.textContent = 'Creating link…';
      fetch(API + '/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ handles: load() })
      })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (d) {
          var url = location.origin + '/pages/wishlist?w=' + d.code;
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(function () {
              sp.textContent = 'Link copied — send it to a friend!';
            }, function () { sp.textContent = url; });
          } else { sp.textContent = url; }
        })
        .catch(function () { sp.textContent = 'Failed — try again'; });
    });
    (title || container.firstElementChild).insertAdjacentElement('afterend', btn);
  });
})();
